import React, { useEffect } from "react";
import { HomeAPI } from "../../blocks/home-api";
import { HomeInfo } from "../../blocks/home-info";
import { HomeApplication } from "../../blocks/home-application";
import { HomeBanner } from "../../blocks/home-banner";
import { HomeCertification } from "../../blocks/home-certification";
import { HomeComment } from "../../blocks/home-comment";
import { HomeConnection } from "../../blocks/home-connection";
import { HomeCustomer } from "../../blocks/home-customer";
import { HomeIdentityInfrastructure } from "../../blocks/home-identity-infrastructure";
import { HomeManagement } from "../../blocks/home-management";
import { HomeTryOn } from "../../blocks/home-try-on";
import { MainNews } from "../../blocks/main-news";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import "./styles.less";
import { Helmet } from "react-helmet";
import { useTimeoutFn } from "react-use";

export const HomePage = () => {
  useEffect(() => {
    // _MEIQIA("subSource", "sub_source_6");
    // _MEIQIA("init");
  }, []);
  // useTimeoutFn(() => {
  //   // _MEIQIA("subSource", "sub_source_6");
  //   _MEIQIA("showPanel");
  // }, 30000);
  return (
    <div className="home-page">
      <Helmet>
        <title>
          Authing身份云-SSO单点登录系统-MFA多因素认证-统一身份认证平台-中国版OKTA-零信任-IDaaS-以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" />
      <HomeBanner />
      <HomeCustomer />
      <HomeManagement />
      <HomeAPI />
      <HomeIdentityInfrastructure />
      <HomeApplication />
      <HomeConnection />
      <MainNews />
      <HomeComment />
      <HomeTryOn />
      <HomeCertification />
      <Footer />
    </div>
  );
};
